// Utility to inject LaTeX styles once per document
const LATEX_STYLE_ELEMENT_ID = 'latex-styles';

const latexStyles = `
  .latex-math {
    font-family: 'STIX Two Math', 'Times New Roman', serif;
  }
  .latex-math.block {
    display: block;
    text-align: center;
    margin: 12px 0;
    font-size: 1.2em;
    line-height: 1.4;
  }
  .latex-math.inline {
    display: inline;
    font-size: 1.05em;
  }
  .latex-math .latex-fraction {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin: 0 2px;
  }
  .latex-math .latex-numerator {
    display: block;
    border-bottom: 1px solid currentColor;
    padding-bottom: 1px;
    margin-bottom: 1px;
    line-height: 1.2;
  }
  .latex-math .latex-denominator {
    display: block;
    padding-top: 1px;
    margin-top: 1px;
    line-height: 1.2;
  }
  .latex-math .latex-superscript {
    font-size: 0.75em;
    line-height: 0;
    position: relative;
    vertical-align: super;
    top: -0.3em;
  }
  .latex-math .latex-subscript {
    font-size: 0.75em;
    line-height: 0;
    position: relative;
    vertical-align: sub;
    bottom: -0.2em;
  }
  .latex-math sup, .latex-math sub {
    font-size: 0.75em;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  .latex-math sup {
    top: -0.4em;
  }
  .latex-math sub {
    bottom: -0.2em;
  }
`;

export const ensureLatexStylesInjected = (): void => {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`#${LATEX_STYLE_ELEMENT_ID}`)) return;

  const styleSheet = document.createElement('style');
  styleSheet.id = LATEX_STYLE_ELEMENT_ID;
  styleSheet.textContent = latexStyles;
  document.head.append(styleSheet);
};
